module.exports = __webpack_public_path__ + "img/12_andy_d.bc5ed1e9.png";